import { useQuery } from '@tanstack/react-query'

import { SearchI } from '../../Pages/SearchService'
import { getService } from '../../services/servico'

export const serviceBySlugQueryKey = (slug: string) =>
  ['service', slug] as const

const useServiceBySlug = (slug: string) =>
  useQuery<SearchI | undefined>({
    queryKey: serviceBySlugQueryKey(slug),
    queryFn: async () => {
      const { data } = await getService(slug)
      return data?.results[0]
    },
    enabled: Boolean(slug),
    staleTime: 1000 * 60 * 5,
    cacheTime: 1000 * 60 * 15,
  })

export default useServiceBySlug
